import { AlertCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { useNeedsAttention } from "../../hooks/use-dashboard-extra";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Skeleton } from "../ui/skeleton";

export function NeedsAttention(): React.ReactElement {
  const { data, isLoading } = useNeedsAttention();
  const categories = (data?.categories ?? []).filter((c) => c.count > 0);

  return (
    <Card data-testid="needs-attention-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold flex items-center gap-1.5">
          <AlertCircle className="h-3.5 w-3.5 text-orange-500" />
          Needs Attention
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-2" data-testid="needs-attention-loading">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-2/3" />
          </div>
        ) : categories.length === 0 ? (
          <p className="text-xs text-muted-foreground py-2 text-center" data-testid="needs-attention-empty">
            Nothing needs attention
          </p>
        ) : (
          <div className="space-y-1.5" data-testid="needs-attention-list">
            {categories.map((item) => (
              <Link
                key={item.key}
                to={item.href}
                className="flex items-center justify-between text-sm hover:text-primary transition-colors"
                data-testid={`needs-attention-item-${item.key}`}
              >
                <span>{item.label}</span>
                <span className="font-semibold tabular-nums text-orange-600">{item.count}</span>
              </Link>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
